// extracted by mini-css-extract-plugin
export default {"sidebar_container":"Sidebar_sidebar_container__Gj3bt","sidebar_header":"Sidebar_sidebar_header__PI4nW"};